<template>
    <div :id="'radio--' + component_id" v-if="option_filter">
        <div v-if="options_loaded && passed_filter">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>{{ title }}</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            Question
        ],
        props: {
            title: {
                default(){
                    return 'Frame Material:';
                }
            },
            component_id: {
                default(){
                    return 'frame_material';
                }
            },
            slab: {
                required: true,
            },
            securedByDesign: {
                required: false,
                default(){
                    return 0;
                },
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/frame-material?slab=' + this.slab + '&fabricator_id=' + this.fabricator + '&secured_by_design=' + this.securedByDesign;
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.securedByDesign);
            },
            option_filter() {
                return this.filtered_option_list.length > 1;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.securedByDesign;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
            'filtered_option_list': function (new_val, old_val) {
                nextTick(()=>{
                    var options = $('#radio--' + this.component_id + ' input').not('.icheck');

                    options.addClass('icheck').iCheck({
                        checkboxClass: 'checkboxstyle',
                        radioClass: 'radiostyle',
                        selectClass: 'selectstyle'
                    });

                    options.on('ifChecked', (e) => {
                        this.localTarget = parseInt(e.target.value);
                    });
                });
            }
        },
    }
</script>
